import { render, staticRenderFns } from "./PacksProcessing.vue?vue&type=template&id=66308990&scoped=true&"
import script from "./PacksProcessing.vue?vue&type=script&lang=js&"
export * from "./PacksProcessing.vue?vue&type=script&lang=js&"
import style0 from "./PacksProcessing.vue?vue&type=style&index=0&id=66308990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66308990",
  null
  
)

export default component.exports